import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { filterKeys } from '../../utils/common.js';
import { useId } from '../../utils/hooks/useId.js';
import './PageContainerContent.scss.js';
import { useScrollStatusVertical } from '../../utils/hooks/useScrollStatusVertical.js';

const bem = Bem.create("vai-page-container-content");
const PageContainerContent = React.forwardRef((props, ref) => {
  const { onScrollStatusChange, htmlId, dataTa = "vai-page-container-content", children, className, hasSpacing = true, ...rest } = props;
  const containerNodeRef = React.useRef(null);
  const id = useId(htmlId, ["page container content"]);
  const contentClasses = addClass(bem.block(hasSpacing === false && "no-spacing"), className);
  const restFiltered = filterKeys(rest, ["onScrollStatusChange"]);
  useScrollStatusVertical(containerNodeRef, onScrollStatusChange);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    ref,
    "data-ta": dataTa,
    className: contentClasses,
    ...restFiltered
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("children")(),
    ref: containerNodeRef
  }, children));
});

export { PageContainerContent };
